import React from 'react';
import BaseClass from '@/pages/BaseClass';
import ChargeRecord from '@/components/ChargeRecord';

import $ from 'jquery';
import {
	Form,
	Table,
	Button,
	Input,
	InputNumber,
	Radio,
	Modal,
} from 'antd'
import {
	CommonValue,
	ngUrl,
	pcUrl,
	confirm,
	message,
	notify,
	httpPost
} from '@/utils/Tools';

const {Column,ColumnGroup} = Table;
export default class App extends BaseClass
{
	constructor(props)
	{
		super(props);
		
		this.state={
			'userInfo':{},
			'rules':{
				'charge_amount':[
					{
						required: true,
						message: '请输入充值金额',
					},
					/*
					{
						type: 'number',
						message: '充值金额为数字格式',
					},
					*/
				],
				'income_amount':[
					{
						required: true,
						message: '请输入到账金额',
					},
					/*
					{
						type: 'number',
						message: '到账金额为数字格式',
					},
					*/
				],
				'method':[
					{
						required: true,
						message: '请选择充值方式',
					},
					{
						type:'enum',
						enum: ['alipay','wechatpay'],
						message: '请选择正确的充值方式',
					},
				],
			},
			
			'eventIndex':0,
			'eventList':[],
			'wechatpay_qrcode':'',
			
			'showChargeDialog':false,
		};
	}
	
	componentDidMount()
	{
		//this.getCompanyInfo();
		this.getUserInfo();
		this.getEventList();
		
		/*
		this.mainForm.setFieldsValue({
			'method':'alipay',
		});
		*/
		//this.changeMethod('allinpay');
		document.title = '活动充值 - ' + CommonValue.get('site_name');
	}
	componentWillUnmount()
	{
		if(this.loop)
			window.clearInterval(this.loop);
	}
	getUserInfo()
	{
		let url = pcUrl('user','info');
		httpPost(url)
			.then(data=>{
				this.setState({
					'userInfo':data,
				});
			});
	}
	
	getEventList()
	{
		let url = pcUrl('user','chargeEventList');
		httpPost(url)
			.then(data=>{
				if(data.length)
				{
					let info = data[0];
					this.mainForm.setFieldsValue({
						'charge_amount':info['charge_amount'],
						'income_amount':info['income_amount'],
						'event_id':data[0]['event_id'],
					});
					//this.changeMethod('allinpay');
				}
				this.setState({
					'eventList':data,
				});
			});
	}
	
	eventChange(index)
	{
		let info = this.state.eventList[index];
		
		this.mainForm.setFieldsValue({
			'event_id':info['event_id'],
			'charge_amount':info['charge_amount'],
			'income_amount':info['income_amount'],
		});
		this.setState({
			'eventIndex':index,
		});
		let method = this.mainForm.getFieldValue('method');
		if(
			method == 'wechatpay' ||
			method == 'allinpay'
		)
			this.changeMethod(method);
	}
	
	changeMethod(method)
	{
		if(this.loop)
			window.clearInterval(this.loop);
		
		if(method == 'wechatpay')
		{
			this.mainForm.validateFields(['event_id','method'])
				.then((info)=>{
					info.method = method;
					//微信充值，获取服务器返回的二维码
					this._submit(info)
						.then(data=>{
							this.setState({
								'wechatpay_qrcode':pcUrl('index','qrcode',{ 'code':escape(data.url), }),
							});
							let paySn = data['pay_sn'];
							paySn = paySn.split('_');
							paySn = paySn[0];
							if(this.loop)
								window.clearInterval(this.loop);
							//监听订单状态
							this.loop = window.setInterval(()=>{
								let url = pcUrl('user','payInfo');
								let param = {
									'pay_sn':paySn,
									'check_status':1,
								};
								httpPost(url,param)
									.then(data=>{
										//如果已支付状态
										if(10 == data.status)
										{
											this.props.history.push('/user/success?out_trade_no='+paySn);
										}
									});
							},2000);
						});
					
					this.mainForm && this.mainForm.setFieldsValue({'method':method});
				});
		}
		else if(method == 'allinpay')
		{
			this.mainForm.validateFields(['event_id'])
				.then((info)=>{
					info.method = method;
					//微信充值，获取服务器返回的二维码
					this._submit(info)
						.then(data=>{
							this.setState({
								'wechatpay_qrcode':pcUrl('index','qrcode',{ 'code':escape(data.url), }),
							});
							let paySn = data['pay_sn'];
							paySn = paySn.split('_');
							paySn = paySn[0];
							//监听订单状态
							this.loop = window.setInterval(()=>{
								let url = pcUrl('user','payInfo');
								let param = {
									'pay_sn':paySn,
									'check_status':1,
								};
								httpPost(url,param)
									.then(data=>{
										//如果已支付状态
										if(10 == data.status)
										{
											//this.props.history.push('/user/success?out_trade_no='+paySn);
											window.location.href = '#/user/success?out_trade_no='+paySn;
										}
									});
							},2000);
						});
					
					this.mainForm && this.mainForm.setFieldsValue({'method':method});
				});
		}
		else
		{
		
			this.mainForm && this.mainForm.setFieldsValue({'method':method});
		}
	}
	
	submit(info)
	{
		this._submit(info)
			.then(data=>{
				//支付宝充值，直接进行跳转
				if(info.method == 'alipay')
					document.write(data);
			});
	}
	
	_submit(info)
	{
		let url = pcUrl('user','chargeFromEvent');
		let param = {
			'event_id':info['event_id'],
			'method': ['alipay','wechatpay','moneypay','allinpay'].indexOf(info.method),
		};
		return new Promise((resolve,reject)=>{
			httpPost(url,param)
				.then(data=>{
					resolve(data);
				})
				.catch(e=>reject(e));
		});
	}
	
	showChargeRecord()
	{
		this.setState({
			'showChargeDialog':true,
		});
	}
	
	render()
	{
		return (
			<div>
				<div className="user-panel">
					<div className="captain">
						<span className="float-right">
							<button className="button button-orange" onClick={()=>this.showChargeRecord()}>
								<span className="fa fa-database"></span>
								充值记录
							</button>
						</span>
						<h3>充值活动</h3>
					</div>
					<div className="panel-body">
						<div className="">
							<Form
								ref={e=>this.mainForm = e}
								onFinish={(data)=>this.submit(data)}
								onFinishFailed={data=>this.focusError(data)}
								labelCol={{ span:3 }}
								wrapperCol={{ span:14 }}>
								<Form.Item label="当前用户">
									{this.state.userInfo['company_name']}
								</Form.Item>
								<Form.Item label="账户余额">
									<span className="text-red"> ￥{this.state.userInfo['money']}</span>
								</Form.Item>
								
								<Form.Item name="event_id" label="充值活动" rules={this.state.rules['event_id']}>
									<div className="button-list">
										<ul>
											{this.state.eventList.map((row,index)=>(
											<li> <a href="javascript:;" className={index == this.state.eventIndex ? 'now':''} onClick={()=>this.eventChange(index)}>{row['event_name']}</a> </li>
											))}
										</ul>
									</div>
								</Form.Item>
								<Form.Item name="charge_amount" label="充值金额" rules={this.state.rules['charge_amount']}>
									<InputNumber disabled style={{'width':'200px'}} />
								</Form.Item>
								<Form.Item name="income_amount" label="到账金额" rules={this.state.rules['income_amount']}>
									<InputNumber disabled style={{'width':'200px'}} />
								</Form.Item>
								<Form.Item name="method" label="充值方式" rules={this.state.rules['method']}>
									<Form.Item shouldUpdate>
										{()=>(
											<>
												<div className="pay-method">
													<ul>
														{/*
															<li onClick={()=>this.changeMethod('alipay')}>
																<Radio checked={this.mainForm && this.mainForm.getFieldValue('method') == 'alipay'} value="alipay"></Radio>
																<img className="alipay-icon" src={require("@/assets/images/alipay.png")} />
															</li>
															<li onClick={()=>this.changeMethod('wechatpay')}>
																<Radio checked={this.mainForm && this.mainForm.getFieldValue('method') == 'wechatpay'} value="wechatpay"></Radio>
																<img className="wechatpay-icon" src={require("@/assets/images/wechatpay.jpg")} />
															</li>
														*/}
														<li onClick={()=>this.changeMethod('allinpay')}>
															<Radio checked={this.mainForm && this.mainForm.getFieldValue('method') == 'allinpay'} value="allinpay"></Radio>
															<img className="wechatpay-icon" src={require("@/assets/images/allinpay.png")} />
														</li>
													</ul>
												</div>
												{this.mainForm && this.mainForm.getFieldValue('method') == 'wechatpay' && (
													<div className="pay-area">
														<div className="pay-area-left">
															<div className="pay-qr">
																{/*
																<img src={require("@/assets/images/wechat_qr.jpg")} />
																*/}
																<img src={this.state.wechatpay_qrcode} />
															</div>
															<div className="pay-attention">
																<dl>
																	<dd className="float-left">
																		<img src={require('@/assets/images/wechatpay_focus_ico.jpg')} />
																	</dd>
																	<dt>
																		请使用微信扫一扫
																		<br/>
																		扫描二维码以完成支付
																	</dt>
																</dl>
															</div>
														</div>
														<div className="pay-area-right">
															<img src={require("@/assets/images/wechatpay_exp.jpg")} />
														</div>
													</div>
												)}
												{this.mainForm && this.mainForm.getFieldValue('method') == 'allinpay' && (
													<div className="pay-area">
														<div className="pay-area-left">
															<div className="pay-qr">
																{/*
																<img src={require("@/assets/images/wechat_qr.jpg")} />
																*/}
																<img src={this.state.wechatpay_qrcode} />
															</div>
															<div className="pay-attention">
																<dl>
																	<dd className="float-left">
																		<img src={require('@/assets/images/wechatpay_focus_ico.jpg')} />
																	</dd>
																	<dt>
																		请使用微信或支付宝扫一扫
																		<br/>
																		扫描二维码以完成支付
																	</dt>
																</dl>
															</div>
														</div>
														{/*
															<div className="pay-area-right">
																<img src={require("@/assets/images/wechatpay_exp.jpg")} />
															</div>
														*/}
													</div>
												)}
											</>
										)}
									</Form.Item>
								</Form.Item>
								
								<Form.Item shouldUpdate wrapperCol={{ offset:3 }}>
								{()=>this.mainForm &&  !['wechatpay','allinpay'].includes(this.mainForm.getFieldValue('method')) && (
									<Button type="primary" htmlType="submit" style={{'width':'18em','height':'36px'}}>确认</Button>
								)}
								</Form.Item>
							</Form>
						</div>
					</div>
				</div>
				<Modal
					title="充值记录"
					width={900}
					visible={this.state.showChargeDialog}
					footer={null}
					onCancel={()=>this.setState({'showChargeDialog':false})}
					>
					<ChargeRecord ref={e=>this.chargeRecord = e} />
				</Modal>
			</div>
		);
	}
}

